const simulatorServers = [
  {
    key: 'cn',
    label: 'CN 服务器',
    apiBase: 'https://diagapi.cn.wwftool.top/api',
    serviceBase: 'https://diagapi.cn.wwftool.top',
  },
  {
    key: 'us',
    label: 'US 服务器',
    apiBase: 'https://diagapi.us.wwftool.top/api',
    serviceBase: 'https://diagapi.us.wwftool.top',
  },
];

const CUSTOM_TEMPLATE_STORAGE_KEY = 'FordDiagnosticSimulator:Templates:v1';

const simulatorDefaults = {
  server: 'cn',
  templateKey: 'connect',
  diagId: 'USAFORD',
  diagVersion: 'V50.75',
  language: 'CN',
  sn: '989340000121',
  vin: '',
  localMac: 'w83Cw03Cw03Cw03Cw03C.03C',
  productType: 'x431',
  wifiMac: 'wCsCwGsOwSJDw4JPwC6E.O3E',
  wifiName: 'Xb6MfrsR3XpN.G3E',
};

const simulatorTemplates = [
  {
    key: 'securityOffline',
    title: '离线安全数据',
    desc: 'funcEx/SecurityOffline',
    funcPath: 'SecurityOffline',
    funcType: 1,
    method: 'POST',
    parm: {
      Seed: '',
      SecurityLevel: '',
      ModuleAddr: '',
    },
  },
  {
    key: 'immoAutoPats',
    title: 'PATS 自动计算',
    desc: 'funcEx/ImmoAutoPats',
    funcPath: 'ImmoAutoPats',
    funcType: 3,
    method: 'POST',
    parm: {
      OutCode: '',
    },
  },
  {
    key: 'immoAuto3Bto3C',
    title: '3B 转 3C',
    desc: 'funcEx/ImmoAuto3Bto3C',
    funcPath: 'ImmoAuto3Bto3C',
    funcType: 4,
    method: 'POST',
    parm: {
      OutCode: '',
    },
  },
  {
    key: 'securityOnline',
    title: '在线安全校验',
    desc: 'funcEx/SecurityOL',
    funcPath: 'SecurityOL',
    funcType: 5,
    method: 'POST',
    parm: {},
  },
  {
    key: 'immoIncode',
    title: '防盗内码',
    desc: 'funcEx/ImmoIncode',
    funcPath: 'ImmoIncode',
    funcType: 6,
    method: 'POST',
    parm: {
      OutCode: '',
    },
  },
  {
    key: 'deliv4Vin',
    title: 'VIN 匹配 Deliver',
    desc: 'funcEx/Deliv4Vin',
    funcPath: 'Deliv4Vin',
    funcType: 10,
    method: 'POST',
    parm: {},
  },
  {
    key: 'connect',
    title: '连接探测',
    desc: 'funcEx/connect',
    funcPath: 'connect',
    funcType: 11,
    method: 'POST',
    parm: {
      ExistsFN: 0,
    },
  },
  {
    key: 'pmiData',
    title: 'PMI 数据',
    desc: 'funcEx/PMIData',
    funcPath: 'PMIData',
    funcType: 12,
    method: 'POST',
    parm: {
      ModuleAddr: '',
      AssemblyPN: '',
    },
  },
  {
    key: 'tcmIdn',
    title: 'TCM IDN',
    desc: 'funcEx/TCMIDN',
    funcPath: 'TCMIDN',
    funcType: 14,
    method: 'POST',
    parm: {},
  },
  {
    key: 'findCanFd',
    title: 'CANFD 试探',
    desc: 'funcEx/FindCANFD',
    funcPath: 'FindCANFD',
    funcType: 15,
    method: 'POST',
    parm: {},
  },
  {
    key: 'vin2Vq',
    title: 'VIN 匹配 VQ',
    desc: 'funcEx/VIN2VQ',
    funcPath: 'VIN2VQ',
    funcType: 18,
    method: 'POST',
    parm: {},
  },
  {
    key: 'downloadVm',
    title: '下载 VIN 数据',
    desc: 'funcEx/DownloadVM',
    funcPath: 'DownloadVM',
    funcType: 19,
    method: 'POST',
    parm: {
      iReqFlag: 0,
    },
  },
  {
    key: 'multPromptText',
    title: '多语言提示文本',
    desc: 'funcEx/MultpromptText',
    funcPath: 'MultpromptText',
    funcType: 20,
    method: 'POST',
    parm: {},
  },
  {
    key: 'multPromptDtc',
    title: 'DTC 多语言文本',
    desc: 'funcEx/MultpromtDTC',
    funcPath: 'MultpromtDTC',
    funcType: 21,
    method: 'POST',
    parm: {},
  },
  {
    key: 'diagMod',
    title: 'VIN 诊断模式',
    desc: 'funcEx/DiagMod',
    funcPath: 'DiagMod',
    funcType: 23,
    method: 'POST',
    parm: {
      ExistsFN: 0,
    },
  },
  {
    key: 'keyCode',
    title: '键盘代码参数',
    desc: 'funcEx/KeyCode',
    funcPath: 'KeyCode',
    funcType: 24,
    method: 'POST',
    parm: {},
  },
  {
    key: 'soVersion',
    title: 'SO 版本',
    desc: 'funcEx/SoVersion',
    funcPath: 'SoVersion',
    funcType: 28,
    method: 'POST',
    parm: {
      Type: 'USAFORD',
    },
  },
  {
    key: 'olCfg',
    title: '在线配置',
    desc: 'funcEx/OLCfg',
    funcPath: 'OLCfg',
    funcType: 29,
    method: 'POST',
    parm: {},
  },
  {
    key: 'collectData',
    title: '收集车型数据',
    desc: 'funcEx/CollectData',
    funcPath: 'CollectData',
    funcType: 30,
    method: 'POST',
    parm: {},
  },
  {
    key: 'sysFuncCfg',
    title: '系统功能配置',
    desc: 'funcEx/SysFuncCfg',
    funcPath: 'SysFuncCfg',
    funcType: 32,
    method: 'POST',
    parm: {},
  },
].map((template) => ({
  enabled: true,
  ...template,
  legacyCommand: `tool_GetIVSData.exe ${template.funcType} 1 1 $AUTH$ <sn> $CC$ $IP$ <vehicle-data>`,
  isBuiltin: true,
  isCustom: false,
}));

function cloneJson(value) {
  return JSON.parse(JSON.stringify(value));
}

function getBrowserStorage() {
  try {
    if (typeof globalThis !== 'undefined' && globalThis.localStorage) {
      return globalThis.localStorage;
    }
  } catch (error) {
    return null;
  }
  return null;
}

function resolveStorageAndOptions(storage, options) {
  if (
    storage &&
    typeof storage === 'object' &&
    typeof storage.getItem !== 'function' &&
    !options
  ) {
    return {
      storage: getBrowserStorage(),
      options: storage,
    };
  }

  return {
    storage: storage === undefined ? getBrowserStorage() : storage,
    options: options || {},
  };
}

function normalizeMethod(value) {
  const method = String(value || 'POST').trim().toUpperCase();
  return method || 'POST';
}

function normalizeParm(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return cloneJson(value);
  }
  return {};
}

function addTemplateRuntimeFields(template, flags = {}) {
  return {
    ...template,
    legacyCommand: `tool_GetIVSData.exe ${template.funcType} 1 1 $AUTH$ <sn> $CC$ $IP$ <vehicle-data>`,
    ...flags,
  };
}

export function normalizeSimulatorTemplate(template) {
  const key = String(template?.key || '').trim();
  const funcPath = String(template?.funcPath || '').trim().replace(/^\/+/, '');
  const funcType = Number(template?.funcType);

  if (!key) {
    throw new Error('模板 key 不能为空');
  }
  if (!/^[A-Za-z0-9_-]{2,64}$/.test(key)) {
    throw new Error('模板 key 只能包含字母、数字、下划线和短横线');
  }
  if (!Number.isInteger(funcType) || funcType <= 0 || funcType > 9999) {
    throw new Error('funcType 必须是 1-9999 的整数');
  }
  if (!funcPath) {
    throw new Error('funcPath 不能为空');
  }
  if (/\s/.test(funcPath)) {
    throw new Error('funcPath 不能包含空白字符');
  }

  const title = String(template?.title || funcPath).trim() || funcPath;
  const desc = String(template?.desc || `funcEx/${funcPath}`).trim() || `funcEx/${funcPath}`;

  return {
    key,
    title,
    desc,
    funcPath,
    funcType,
    method: normalizeMethod(template?.method),
    parm: normalizeParm(template?.parm),
    enabled: template?.enabled !== false,
  };
}

function readCustomTemplates(storage = getBrowserStorage()) {
  if (!storage || typeof storage.getItem !== 'function') {
    return [];
  }

  try {
    const raw = storage.getItem(CUSTOM_TEMPLATE_STORAGE_KEY);
    if (!raw) {
      return [];
    }

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed
      .map((item) => {
        try {
          return normalizeSimulatorTemplate(item);
        } catch (error) {
          return null;
        }
      })
      .filter(Boolean);
  } catch (error) {
    return [];
  }
}

function writeCustomTemplates(templates, storage = getBrowserStorage()) {
  if (!storage || typeof storage.setItem !== 'function') {
    return [];
  }

  const map = new Map();
  templates.forEach((template) => {
    const normalized = normalizeSimulatorTemplate(template);
    map.set(normalized.key, normalized);
  });

  const list = [...map.values()].sort((left, right) => {
    return left.funcType - right.funcType || left.key.localeCompare(right.key);
  });

  storage.setItem(CUSTOM_TEMPLATE_STORAGE_KEY, JSON.stringify(list));
  return list.map((item) => cloneJson(item));
}

export function listCustomSimulatorTemplates(storage = getBrowserStorage()) {
  return readCustomTemplates(storage).map((item) => cloneJson(item));
}

export function saveCustomSimulatorTemplates(templates, storage = getBrowserStorage()) {
  return writeCustomTemplates(templates, storage);
}

export function upsertSimulatorTemplate(template, storage = getBrowserStorage()) {
  const normalized = normalizeSimulatorTemplate(template);
  const existing = readCustomTemplates(storage).filter((item) => item.key !== normalized.key);
  return writeCustomTemplates([...existing, normalized], storage)
    .find((item) => item.key === normalized.key);
}

export function deleteCustomSimulatorTemplate(key, storage = getBrowserStorage()) {
  const next = readCustomTemplates(storage).filter((item) => item.key !== key);
  return writeCustomTemplates(next, storage);
}

export function resetSimulatorTemplates(storage = getBrowserStorage()) {
  if (storage && typeof storage.removeItem === 'function') {
    storage.removeItem(CUSTOM_TEMPLATE_STORAGE_KEY);
  }
}

export function notifySimulatorTemplatesChanged() {
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('ford-simulator-templates-changed'));
    }
  } catch (error) {
    // Ignore environments without CustomEvent support.
  }
}

export function listSimulatorTemplates(storage, options) {
  const resolved = resolveStorageAndOptions(storage, options);
  const customTemplates = readCustomTemplates(resolved.storage);
  const builtinKeys = new Set(simulatorTemplates.map((item) => item.key));
  const merged = new Map();

  simulatorTemplates.forEach((template) => {
    merged.set(template.key, addTemplateRuntimeFields(template, {
      isBuiltin: true,
      isCustom: false,
    }));
  });

  customTemplates.forEach((template) => {
    const previous = merged.get(template.key);
    const isBuiltin = builtinKeys.has(template.key);
    merged.set(template.key, addTemplateRuntimeFields({
      ...(previous || {}),
      ...template,
    }, {
      isBuiltin,
      isCustom: true,
    }));
  });

  return [...merged.values()]
    .filter((template) => resolved.options.includeDisabled || template.enabled !== false)
    .sort((left, right) => left.funcType - right.funcType || left.key.localeCompare(right.key))
    .map((item) => cloneJson(item));
}

export function listSimulatorServers() {
  return simulatorServers.map((item) => cloneJson(item));
}

export function getSimulatorServer(key) {
  const server = simulatorServers.find((item) => item.key === key) || simulatorServers[0];
  return cloneJson(server);
}

export function getSimulatorDefaults() {
  return cloneJson(simulatorDefaults);
}

export function getSimulatorTemplate(key, storage) {
  const templates = listSimulatorTemplates(storage);
  const template = templates.find((item) => item.key === key) ||
    templates.find((item) => item.key === simulatorDefaults.templateKey) ||
    templates[0] ||
    simulatorTemplates[0];
  return cloneJson(template);
}

export function normalizeJsonText(text) {
  try {
    const parsed = JSON.parse(String(text || '{}'));
    return JSON.stringify(parsed, null, 2);
  } catch (error) {
    throw new Error('JSON 格式不正确');
  }
}

function readOption(options, key) {
  const value = options?.[key];
  if (value === undefined || value === null || value === '') {
    return simulatorDefaults[key];
  }
  return String(value).trim();
}

function buildBasicParm(options) {
  return {
    DiagId: readOption(options, 'diagId'),
    DiagVersion: readOption(options, 'diagVersion'),
    Languege: readOption(options, 'language'),
    LocalMac: simulatorDefaults.localMac,
    TCURL: simulatorDefaults.productType,
    WifiMac: simulatorDefaults.wifiMac,
    WifiName: simulatorDefaults.wifiName,
  };
}

function buildParm(options) {
  return JSON.parse(normalizeJsonText(options?.parmText || '{}'));
}

export function buildNewToolBody(options) {
  const basicParm = buildBasicParm(options);

  return {
    BasicParm: basicParm,
    Parm: buildParm(options),
    autoCode: basicParm.DiagId,
    sn: readOption(options, 'sn'),
    vin: readOption(options, 'vin').toUpperCase(),
  };
}

function vehicleDataPairs(options) {
  const basicParm = buildBasicParm(options);

  return [
    ['Vin', readOption(options, 'vin').toUpperCase()],
    ['BoxInfo', 'NULL'],
    ['Uid', 'NULL'],
    ['DiagVersion', basicParm.DiagVersion],
    ['DiagId', basicParm.DiagId],
    ['Languege', basicParm.Languege],
    ['LocalMac', basicParm.LocalMac],
    ['WifiMac', basicParm.WifiMac],
    ['WifiName', basicParm.WifiName],
    ['TCURL', basicParm.TCURL],
  ];
}

export function buildLegacyVehicleData(options) {
  return vehicleDataPairs(options)
    .map(([key, value]) => `${key},${value}!`)
    .join('');
}

export function buildLegacyMessageBody(options, storage) {
  const template = getSimulatorTemplate(options?.templateKey, storage);
  return `/${template.funcType}/1/1/$AUTH$/${readOption(options, 'sn')}/$CC$/$IP$/${buildLegacyVehicleData(options)}`;
}

export function buildLegacyExeCommand(options, storage) {
  const template = getSimulatorTemplate(options?.templateKey, storage);
  return `tool_GetIVSData.exe ${template.funcType} 1 1 $AUTH$ ${readOption(options, 'sn')} $CC$ $IP$ ${buildLegacyVehicleData(options)}`;
}

export function buildRequestPreview(options, storage) {
  const payload = buildSimulatorPayload(options, storage);
  const bodyText = typeof payload.body === 'string'
    ? payload.body
    : JSON.stringify(payload.body, null, 2);

  return [
    `${payload.method} ${payload.endpoint}`,
    'Authorization: Bearer <网站登录 token>',
    `Content-Type: ${payload.contentType}`,
    '',
    bodyText,
  ].join('\n');
}

export function buildSimulatorRunRequest(options, storage) {
  const template = getSimulatorTemplate(options?.templateKey, storage);
  const server = getSimulatorServer(options?.server);
  const engine = options?.engine === 'legacy' ? 'legacy' : 'new';

  const request = {
    engine,
    server: server.key,
    templateKey: template.key,
    diagId: readOption(options, 'diagId'),
    diagVersion: readOption(options, 'diagVersion'),
    language: readOption(options, 'language'),
    sn: readOption(options, 'sn'),
    vin: readOption(options, 'vin').toUpperCase(),
    parm: buildParm(options),
    execute: options?.execute !== false,
  };

  if (options?.dryRun !== undefined) {
    request.dryRun = Boolean(options.dryRun);
  }
  if (options?.timeoutMs !== undefined && options?.timeoutMs !== '') {
    request.timeoutMs = Number(options.timeoutMs);
  }

  return request;
}

export function buildSimulatorPayload(options, storage) {
  const template = getSimulatorTemplate(options?.templateKey, storage);
  const server = getSimulatorServer(options?.server);
  const engine = options?.engine === 'legacy' ? 'legacy' : 'new';

  if (engine === 'legacy') {
    return {
      engine,
      server: server.key,
      templateKey: template.key,
      funcPath: template.funcPath,
      funcType: template.funcType,
      method: 'POST',
      endpoint: `${server.serviceBase}/services/v2/runcmd/tool_GetIVSData.exe`,
      contentType: 'text/plain',
      body: buildLegacyMessageBody(options, storage),
      backendExeCommand: buildLegacyExeCommand(options, storage),
      legacyCommand: template.legacyCommand,
    };
  }

  return {
    engine,
    server: server.key,
    templateKey: template.key,
    funcPath: template.funcPath,
    funcType: template.funcType,
    method: template.method,
    endpoint: `${server.apiBase}/v1/funcEx/${template.funcPath}`,
    contentType: 'application/json',
    body: buildNewToolBody(options),
    legacyCommand: template.legacyCommand,
  };
}
